/** NKLEAN logo (dark text, for the app's always-light screens). */
export function BrandImage({ height }: { height: number }) {
  const width = Math.round((height * 640) / 153);
  return (
    <img src="/brand/nklean-logo-ink.png" alt="NKLEAN Commercial Cleaning" width={width} height={height} />
  );
}
